import React from 'react';
import { BaseFeaturedSearchCard } from '../Base/Featured';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { SearchCard } from '../types';
import {
  Price,
  GrayUIText,
  Title,
  BottomContent,
  DisclaimerContentText,
} from '../Base/styles';
import { BoxConditionIcon, TruckIcon, MapMarkerIcon } from '../../../../assets';

const StyledContentText = styled(DisclaimerContentText)`
  white-space: normal;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  width: 149px;
`;

const PriceContainer = styled.div`
  gap: ${theme.spacings[1].rem};
`;

const PriceCondition = styled.span`
  ${theme.typography.headings[5]['sm-lg']};
  color: ${theme.colors.neutrals.solidGrays[3]};
`;

export const AutoBuyNowFeaturedSearchCard: React.FC<
  SearchCard<'AutoBuyNow'>
> = ({
  title,
  price,
  condition,
  location,
  isDelivery,
  data,
  type,
  ...props
}) => {
  return (
    <BaseFeaturedSearchCard {...props}>
      <Content>
        <Title>{title}</Title>

        <PriceContainer>
          <Price>
            {price}
            <PriceCondition>*</PriceCondition>
          </Price>
          <StyledContentText>{data?.disclaimerText}</StyledContentText>
        </PriceContainer>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.primary.graysGray}
            />
            {condition}
          </GrayUIText>
          {(condition as string).length < 13 && (
            <GrayUIText>
              {isDelivery ? (
                <>
                  <TruckIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  Delivery
                </>
              ) : (
                <>
                  <MapMarkerIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  {location}
                </>
              )}
            </GrayUIText>
          )}
        </BottomContent>
      </Content>
    </BaseFeaturedSearchCard>
  );
};
